import api from "./axios";

export type EntityType = "truck" | "city" | "vendor" | "user" | "truckGroup" | "truckHistory";

export interface ImportDataPayload {
  entity: EntityType;
  data: Record<string, any>[];
  execute?: boolean;
}

export interface ValidationResult {
  entity: Record<string, any>;
  validation: {
    isValid: boolean;
    invalidReason?: string;
  };
}

export interface ImportDataResponse {
  entity: string;
  total: number;
  valid: number;
  invalid: number;
  imported?: number;
  entities?: Record<string, any>[];
  validations?: ValidationResult[];
}

export const importDataApi = async (payload: ImportDataPayload): Promise<ImportDataResponse> => {
  try {
    const response = await api.post<ImportDataResponse | { data: ImportDataResponse }>(
      "/api/v1/dtools/dataImporter",
      payload,
    );
    // Handle both direct response and wrapped response
    const data = response.data as ImportDataResponse | { data: ImportDataResponse };
    if ("data" in data && typeof data.data === "object" && "entity" in data.data) {
      return data.data;
    }
    return data as ImportDataResponse;
  } catch (error) {
    console.error("Error importing data:", error);
    throw error;
  }
};
